import { useEffect } from 'react'

/**
 * Set the document title for a screen.
 *
 * Every tab read the same thing regardless of where you were, so two tabs open
 * on different jobs were indistinguishable and browser history was useless. The
 * page comes first because a tab strip truncates from the right.
 *
 * The suffix is built from the brand constants rather than typed again, so
 * renaming the product renames the tab.
 */
import { PARENT_NAME, PRODUCT_NAME } from './components/Brand'

const SUFFIX = `${PRODUCT_NAME} · ${PARENT_NAME}`

export function usePageTitle(title?: string | null): void {
  useEffect(() => {
    const next = title ? `${title} · ${SUFFIX}` : SUFFIX
    const previous = document.title
    document.title = next
    return () => {
      document.title = previous
    }
  }, [title])
}
